"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("../colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  primary: {
    light: _colors["default"].additional.lightMain,
    main: _colors["default"].additional.main,
    dark: _colors["default"].additional.dark,
    contrastText: _colors["default"].text.white
  },
  secondary: {
    light: _colors["default"].secondary.lightMain,
    main: _colors["default"].secondary.main,
    dark: _colors["default"].secondary.darkMain,
    contrastText: _colors["default"].text.white
  },
  error: {
    light: _colors["default"].error.lightMain,
    main: _colors["default"].error.main,
    dark: _colors["default"].error.darkMain,
    contrastText: _colors["default"].text.white
  },
  warning: {
    light: _colors["default"].warning.lightMain,
    main: _colors["default"].warning.main,
    dark: _colors["default"].warning.darkMain,
    contrastText: _colors["default"].text.title
  },
  info: {
    light: _colors["default"].warning.lightMain,
    main: _colors["default"].warning.main,
    dark: _colors["default"].warning.darkMain,
    contrastText: _colors["default"].text.title
  },
  success: {
    light: _colors["default"].secondary.lightMain,
    main: _colors["default"].secondary.main,
    dark: _colors["default"].secondary.darkMain,
    contrastText: _colors["default"].text.white
  },
  "default": {
    light: _colors["default"]["default"].lightMain,
    main: _colors["default"]["default"].main,
    dark: _colors["default"]["default"].darkMain,
    contrastText: _colors["default"].text.title
  }
};
exports["default"] = _default;